export default __webpack_public_path__ + "static/media/ketosis.daa44281.svg";